import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { FormattedMessage } from 'react-intl';
import { getContentBlockItemsByName, getContentBlockMixedItems, getContentBlockMixedItem, getContentBlockItemValue } from '../../../Cms/CmsActions.js';

import Icon from '../../../../components/Content/Icon.js';
import PredictiveLink from '../../../Cms/components/view/PredictiveLink.js';
import CurrencySwitcher from '../../../Currency/components/switch/CurrencySwitcher.js';
import LocaleSwitcher from '../../../Intl/components/switch/LocaleSwitcher.js';

function PanelMainMenu({ panel, isMobile = false, closeMenu = null }) {
    const [isOpen, setIsOpen] = useState(true);

    const handleClose = event => {
        setIsOpen(false);
        if(closeMenu) {
            closeMenu(event);
        }
    };

	const title = getContentBlockItemValue(panel.blocks, 'title');
    const links = getContentBlockItemsByName(panel.blocks, 'links');

	// Optional editorial article/blog strip (rendered at the bottom when filled in the CMS)
	const blogTitle = getContentBlockItemValue(panel.blocks, 'blogTitle');
	const articles = getContentBlockItemsByName(panel.blocks, 'articles').filter(item => getContentBlockMixedItem(item, 'article') && getContentBlockMixedItem(item, 'article').path);
	const isSingleArticle = articles.length === 1;
	const articleCols = Math.min(articles.length, 3);

    if(links && links.length) {
        return (
            <div className={classnames('main-menu', 'mega-menu', 'position-relative', 'overflow-hidden', isMobile && ['mt-4', 'mobile'], isOpen && 'open')}>
				<div className="mega-head d-flex justify-content-between align-items-center p-1 py-2 p-sm-2 bg-light z-3">
					<span className="mega-title d-inline-flex align-items-center fw-bold text-uppercase">
						<span className="d-inline-flex"><Icon icon="menu" /></span> {title}
					</span>
					<div>
						{closeMenu && (
							<button type="button" aria-label="Close menu" className="mega-close ms-auto d-inline-flex align-items-center bg-transparent border-0 fw-bold text-uppercase rounded-pill" onClick={handleClose}>
								<FormattedMessage id="close" defaultMessage="Close" />
								<Icon icon="close" className="ms-2" />
							</button>
						)}
						<div className="d-flex justify-content-end gap-3">
							<CurrencySwitcher />
							<LocaleSwitcher />
						</div>
					</div>
				</div>

				<div className="mega-grid mt-5 mt-md-1 z-2">
					{links.filter(link => getContentBlockMixedItem(link, 'mainLevel') && getContentBlockMixedItem(link, 'mainLevel').path).map(link => {
						const main = getContentBlockMixedItem(link, 'mainLevel');
						const subs = getContentBlockMixedItems(link, 'subLevel');
						return (
							<div key={main.path} className="mega-col">
								<PredictiveLink tag="a" href={main.path} className="col-head d-block position-relative fw-bold text-uppercase text-decoration-none mb-1 mb-md-2 ms-2" onClick={handleClose}>{main.text}</PredictiveLink>
								{subs && subs.length ? (
									<ul className="list-unstyled d-flex flex-column mb-0">
										{subs.map(sub => (
											<li key={sub.path}>
												<PredictiveLink tag="a" href={sub.path} className="dm-link d-flex align-items-center fw-medium text-decoration-none rounded-3" usePrefetch onClick={handleClose}>
													<Icon icon="chevron-right" className="arr" />
													<span className="lbl position-relative">{sub.text}</span>
												</PredictiveLink>
											</li>
										))}
									</ul>
								) : null}
							</div>
						);
					})}
				</div>

				{articles.length > 0 && (
					<div className="article">
						{blogTitle && <p className="article-eyebrow fw-bold text-uppercase">{blogTitle}</p>}
						<div className={classnames('article-grid', `cols-${articleCols}`)}>
							{articles.map(item => {
								const article = getContentBlockMixedItem(item, 'article');
								const excerpt = getContentBlockMixedItems(item, 'excerpt')[0];
								return (
									<PredictiveLink key={article.path} tag="a" href={article.path} className={classnames('article-content text-decoration-none d-flex', isSingleArticle ? 'flex-column flex-md-row align-items-md-center justify-content-between gap-3 gap-md-4' : 'flex-column gap-1')} usePrefetch onClick={handleClose}>
										<span className={classnames('d-flex flex-column gap-1', isSingleArticle && 'flex-grow-1')}>
											<span className="article-content-title d-inline-flex align-items-center fw-bold">
												{article.text}
												{!isSingleArticle && <Icon icon="arrow-right" className="arr2 ms-2" />}
											</span>
											{excerpt && excerpt.text && <span className="article-content-excerpt">{excerpt.text}</span>}
										</span>
										{isSingleArticle && (
											<span className="article-read-btn d-inline-flex align-items-center fw-bold text-uppercase flex-shrink-0 rounded-pill">
												<FormattedMessage id="readMore" defaultMessage="Read more" />
												<Icon icon="arrow-right" className="arr2 ms-2" />
											</span>
										)}
									</PredictiveLink>
								);
							})}
						</div>
					</div>
				)}
            </div>
        );
    }
    return null;
}

PanelMainMenu.propTypes = {
    panel: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    closeMenu: PropTypes.func,
};

export default PanelMainMenu;
